export default __webpack_public_path__ + "static/media/win.46ad9704.mp3";